export default __webpack_public_path__ + "static/media/usersBg.8b1ba409.jpg";